type Variant = "default" | "day-month-year" | "full-date";
export default function convertDate(
  date: string | number | Date | null | undefined,
  variant: Variant = "default"
) {
  if (!date) return null;
  const options: Record<Variant, Intl.DateTimeFormatOptions> = {
    default: {
      year: "numeric",
      month: "short",
      day: "2-digit",
    },
    "day-month-year": {
      year: "numeric",
      month: "short",
      day: "2-digit",
    },
    "full-date": {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    },
  };
  const locale = variant === "day-month-year" ? "en-gb" : "en-us";
  return new Date(date).toLocaleString(locale, options[variant]);
}
